import React from "react";
import _ from "lodash";
import { injectIntl } from "react-intl";
import { ColumnDefinition, RowDefinition } from "griddle-react";
import { connect } from "react-redux";

import { Album } from "@music/models";
import { messages as mMessages } from "@music/messages";
import { Table } from "@ui/Table";
import { CellBasicNumber, CellViewLink, CellViewImageLink } from "@ui/Table/Cells";
import { compose } from "@util/compose";
import { SalesState } from "../../models";
import { messages } from "../../messages";
import { IntlProps, SaleRow, getAggregateSalesForTable, getSalesTypes } from "../../selectors";

interface AlbumSalesTableProps {
    trackId?: number;
    artistId?: number;
    albums: Album[];
}

interface AlbumSalesTableStateProps {
    data: SaleRow[];
    types: string[];
}

// Type the table component
type TypedTable = new () => Table<SaleRow>;
const TypedTable = Table as TypedTable;

type Props = AlbumSalesTableProps & AlbumSalesTableStateProps & IntlProps;

class AlbumSalesTable extends React.Component<Props> {
    private key: number = 1;

    public componentWillReceiveProps(nextProps: Props) {
        // Force a re-render if the columns change
        if (this.props.types !== nextProps.types) {
            this.key++;
        }
    }

    public render() {
        const { data, types, intl } = this.props;

        let cols = [
            <ColumnDefinition
                key="image"
                id="entity.artwork.thumbSmallFile.file"
                title=" "
                customComponent={CellViewImageLink}
                sortable={false} />,
            <ColumnDefinition
                key="title"
                id="entity.title"
                title={intl.formatMessage(mMessages.albumColumnTitle)}
                customComponent={CellViewLink} extraData={{entity: "album"}} />,
            <ColumnDefinition
                key="upc"
                id="entity.upc"
                title={intl.formatMessage(mMessages.albumColumnUpc)} />,
        ];
        cols = cols.concat(
            _.map(types, (type) => (
                <ColumnDefinition key={type} id={"sales.types." + type}
                    title={intl.formatMessage({ id: "sales.graph." + type })}
                    customComponent={CellBasicNumber} />
            )),
        );
        cols.push(
            <ColumnDefinition
                key="total"
                id="sales.total"
                title={intl.formatMessage(messages.salesTotal)}
                customComponent={CellBasicNumber} />,
        );

        return (
            <div className="album-sales-table">
                <TypedTable key={this.key} data={data} layout="basic" pageSize={data.length}>
                    <RowDefinition>
                        {cols}
                    </RowDefinition>
                </TypedTable>
            </div>
        );
    }
}

const mapStateToProps = (state: SalesState, props: AlbumSalesTableProps) => {
    const newProps = {
        trackId: props.trackId,
        artistId: props.artistId,
        albums: props.albums,
    };
    const types = getSalesTypes(state, newProps);
    return {
        data: getAggregateSalesForTable(state, newProps),
        types: types == null ? [] : types,
    } as AlbumSalesTableStateProps;
};

const ConnectedAlbumSalesTable = compose<Props, AlbumSalesTableProps>(
    injectIntl,
    connect(mapStateToProps, null),
)(AlbumSalesTable);

export {
    AlbumSalesTable as AlbumSalesTablePresenter,
    ConnectedAlbumSalesTable as AlbumSalesTable,
    Props as AlbumSalesTableProps,
};
